import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-801",
  "use": "icon-801-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-801\" viewBox=\"0 0 16 16\" id=\"icon-801\">\n  <path d=\"M8 0a7.955 7.955 0 0 0-.795.04 7.985 7.985 0 0 0-.631.094c-.043.008-.087.011-.13.02a7.998 7.998 0 0 0 0 15.692c.043.009.087.012.13.02.208.037.417.073.631.094A8 8 0 1 0 8 0zm0 15.5a7.46 7.46 0 0 1-1.668-.188 8.497 8.497 0 0 0 0-14.623A7.5 7.5 0 1 1 8 15.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol